import { Link } from "react-router-dom";
import { Seo } from "@/components/Seo";
import { ArPageHero, ArBlock, ArGrid, ArBullets, ArContactCTA, ArWhatHappensNext } from "@/pages/ar/_ArShared";

const PRODUCTS = [
  { title: "Twasal Awasal — منصة التوصيل والخدمات اللوجستية", desc: "تطبيق العميل، تطبيق السائق، الإرسال، وبوابة الشاحن.", status: "جاهز للإطلاق · عُمان" },
  { title: "نظام إدارة المستودعات", desc: "استلام، تخزين، انتقاء، تعبئة، إرسال، وجرد.", status: "تم التسليم · سنغافورة وماليزيا والولايات المتحدة" },
  { title: "نظام تخطيط موارد الشركات اللوجستية", desc: "دمج المالية والعمليات والإرسال في نظام واحد.", status: "تم التسليم · الولايات المتحدة" },
  { title: "منصة إدارة المعارض", desc: "المخزون، المبيعات، العملاء المحتملون، الحجوزات، المستندات.", status: "مباشر · مسقط" },
  { title: "تجارة السوق الإلكترونية", desc: "متعدد البائعين، طلبات مقسومة، وتوزيعات مالية.", status: "قيد التطوير" },
  { title: "Meyar — الحوكمة والامتثال", desc: "حوكمة المؤسسات وحوكمة الأمن السيبراني.", status: "قيد التطوير" },
];

const INDUSTRIES = [
  { title: "الخدمات اللوجستية والنقل", desc: "أنظمة الإرسال، المستودعات، إدارة الأسطول." },
  { title: "التجزئة والتجارة الإلكترونية", desc: "أسواق متعددة البائعين، إدارة المخزون، تحصيل المدفوعات." },
  { title: "القطاع الحكومي", desc: "بوابات المواطنين، أنظمة سير العمل، والشفافية." },
  { title: "الخدمات المصرفية والمالية", desc: "أنظمة تعرف على العميل، تدقيق داخلي، امتثال." },
  { title: "الرعاية الصحية", desc: "إدارة المرضى، الحجوزات، والملفات السريرية." },
  { title: "العقارات والمرافق", desc: "التأجير، الصيانة، ودخول المباني." },
  { title: "التعليم", desc: "منصات التعلم، القبول، وإدارة الطلاب." },
  { title: "الصناعة والتوزيع", desc: "أوامر الإنتاج، تخطيط الموارد، والجودة." },
  { title: "السيارات", desc: "المعارض، خدمة ما بعد البيع، وقطع الغيار." },
];

export default function HomeAr() {
  return (
    <div data-testid="home-ar">
      <Seo
        title="برمجيات تُدير أعمالك"
        description="شركة تقنية مقرها عُمان تصمم وتبني وتُشغّل المنصات المخصصة ومنتجات SaaS وتطبيقات الجوال."
      />

      <section className="relative overflow-hidden bg-wafa-deep text-white">
        <div className="mx-auto max-w-7xl px-4 py-20 lg:px-6 lg:py-28">
          <div className="inline-flex items-center gap-2 rounded-full border border-white/20 bg-white/5 px-4 py-1.5 text-xs">
            <span className="h-1.5 w-1.5 rounded-full bg-wafa-sunshine" />
            شركة تقنية مقرها عُمان · الشريك التقني لمجموعة Altalib
          </div>
          <h1 className="mt-6 max-w-4xl font-heading text-4xl font-semibold leading-tight sm:text-5xl lg:text-6xl">
            برمجيات تُدير أعمالك، <span className="text-wafa-sunshine">لا العكس.</span>
          </h1>
          <p className="mt-6 max-w-3xl text-base leading-relaxed text-white/85 lg:text-lg">
            نصمم ونبني ونؤمّن المنصات المخصصة ومنتجات SaaS وتطبيقات الجوال — ثم نبقى لتشغيلها. شركة مقرها عُمان، بفريق هندسي في عُمان والهند والولايات المتحدة والفلبين.
          </p>
          <div className="mt-8 flex flex-wrap gap-3">
            <Link to="/ar/company/contact" className="inline-flex items-center gap-1.5 rounded-md bg-wafa-primary px-5 py-2.5 text-sm font-semibold text-white hover:bg-wafa-sunshine hover:text-wafa-deep">
              احجز مكالمة استكشافية مجانية
            </Link>
            <Link to="/ar/work" className="inline-flex items-center gap-1.5 rounded-md border border-white/25 px-5 py-2.5 text-sm font-semibold text-white hover:border-white">
              تعرّف على أعمالنا
            </Link>
          </div>
        </div>
      </section>

      <ArBlock tint="cream" heading="عملك نما. أنظمتك لم تواكب النمو.">
        <p className="max-w-4xl text-base leading-relaxed text-wafa-ink/85 lg:text-lg">
          جداول البيانات التي أدارت أعمالك في السنوات الأولى بدأت تتعثر. الأرقام تُعاد كتابتها يدويًا بين أنظمة لا تتواصل، تحضير التقارير يستغرق أيامًا، والمورد الذي بنى منصتكم السابقة توقف عن الرد. هذه ليست مشكلة تقنية بعد — لكن إن تُركت، ستصبح كذلك.
        </p>
      </ArBlock>

      <ArBlock tint="white" heading="كيف نساعدك: محرك بناء وفا">
        <ArGrid columns={4} items={[
          { title: "البناء", desc: "منصات مخصصة، حلول SaaS، تطبيقات جوال وويب. برمجيات جاهزة للاستخدام كل أسبوعين." },
          { title: "الذكاء الاصطناعي", desc: "الذكاء الاصطناعي حيث يُحدث فرقًا فعليًا: مساعدون، معالجة مستندات، أتمتة بإشراف بشري." },
          { title: "الحوكمة", desc: "Meyar، منصتنا لحوكمة المؤسسات وحوكمة الأمن السيبراني." },
          { title: "التشغيل", desc: "مراقبة وتحديثات ودعم بموجب اتفاقية خدمة مكتوبة." },
        ]} />
        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2">
          <div className="rounded-md bg-wafa-cream/60 p-5 text-sm font-semibold text-wafa-deep">نطاق ثابت وسعر ثابت</div>
          <div className="rounded-md bg-wafa-cream/60 p-5 text-sm font-semibold text-wafa-deep">أوقفوا العمل عند أي مرحلة</div>
        </div>
      </ArBlock>

      <section className="bg-wafa-cream/40">
        <div className="mx-auto grid max-w-7xl grid-cols-1 gap-8 px-4 py-16 sm:grid-cols-3 lg:px-6 lg:py-20">
          {[
            { n: "4", t: "الدول التي يعمل منها فريقنا", s: "عُمان · الهند · الولايات المتحدة · الفلبين" },
            { n: "90", t: "أيام الدعم المجاني بعد التسليم" },
            { n: "2040", t: "نبني من أجل رؤية عُمان 2040" },
          ].map((x, i) => (
            <div key={i} className="rounded-lg bg-white p-6">
              <div className="font-heading text-4xl font-bold text-wafa-primary lg:text-5xl">{x.n}</div>
              <div className="mt-3 text-sm font-semibold text-wafa-deep">{x.t}</div>
              {x.s ? <div className="mt-1 text-xs text-wafa-ink/70">{x.s}</div> : null}
            </div>
          ))}
        </div>
      </section>

      <ArBlock tint="white" heading="صُنعت في عُمان. تعمل الآن.">
        <p className="max-w-3xl text-base text-wafa-ink/80">منصات صممناها وبنيناها وما زلنا نُشغّلها — والمزيد قيد التطوير.</p>
        <div className="mt-8 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {PRODUCTS.map((p, i) => (
            <div key={i} className="rounded-lg border border-wafa-deep/10 bg-white p-6">
              <div className="text-[10px] font-semibold uppercase tracking-widest text-wafa-primary">{p.status}</div>
              <div className="mt-3 font-heading text-lg font-semibold text-wafa-deep">{p.title}</div>
              <p className="mt-3 text-sm leading-relaxed text-wafa-ink/80">{p.desc}</p>
            </div>
          ))}
        </div>
      </ArBlock>

      <ArBlock tint="cream" heading="قانون حماية البيانات الشخصية في عُمان أصبح نافذًا. هل برمجياتكم جاهزة؟">
        <div className="space-y-4 text-base leading-relaxed text-wafa-ink/85 lg:text-lg">
          <p>صدر القانون بموجب المرسوم السلطاني رقم 6/2022. ودخلت لائحته التنفيذية الصادرة بموجب القرار الوزاري رقم 34/2024 حيز التنفيذ الكامل اعتبارًا من 5 فبراير 2026، تحت إشراف وزارة النقل والاتصالات وتقنية المعلومات.</p>
          <p>يتطلب القانون: موافقة صريحة وموثقة، إشعارات خصوصية واضحة، الرد على طلبات الأفراد خلال 45 يومًا دون مقابل، تعيين مسؤول حماية بيانات، ضوابط على نقل البيانات خارج السلطنة، والإبلاغ عن أي خرق خلال 72 ساعة.</p>
          <p>نبني كل ذلك داخل المنتج منذ أول مرحلة تطوير، ونتعامل مع مكان تخزين البيانات كقرار تتخذه الشركة بوعي، لا كافتراض متوارث.</p>
        </div>
        <div className="mt-8 flex flex-wrap gap-3">
          <Link to="/ar/meyar" className="inline-flex items-center gap-1.5 rounded-md bg-wafa-deep px-5 py-2.5 text-sm font-semibold text-white hover:bg-wafa-primary">تعرّف على Meyar</Link>
          <Link to="/tools/pdpl-readiness-check" className="inline-flex items-center gap-1.5 rounded-md border border-wafa-deep/20 px-5 py-2.5 text-sm font-semibold text-wafa-deep hover:border-wafa-deep">تحقق من جاهزيتكم لقانون حماية البيانات</Link>
        </div>
      </ArBlock>

      <ArBlock tint="white" heading="الصناعات التي نبني من أجلها">
        <ArGrid columns={3} items={INDUSTRIES} />
      </ArBlock>

      <ArBlock tint="cream" heading="عن وفا سوليوشنز">
        <p className="max-w-4xl text-base leading-relaxed text-wafa-ink/85 lg:text-lg">
          نحن شركة تقنية مقرها سلطنة عُمان، والشريك التقني لمجموعة Altalib. منصتنا للتوصيل والخدمات اللوجستية، نظام إدارة المستودعات، منصة إدارة المعارض، و Meyar جميعها ملك لنا. صممناها وبنيناها ونُشغّلها. والمزيد قيد التطوير.
        </p>
      </ArBlock>

      <ArBlock tint="white" heading="لماذا نعمل بهذه الطريقة">
        <p className="max-w-4xl text-base leading-relaxed text-wafa-ink/85 lg:text-lg">
          غالبًا ما تفشل المشاريع لأسباب لا علاقة لها بالكود. كان النطاق غامضًا، ولم يظهر شيء لأشهر، واختفى المورد بعد الإطلاق. بنينا هذه الشركة لتعمل بالعكس تمامًا — ترون برمجيات تعمل كل أسبوعين، تعرفون تكلفة كل شيء، ونبقى معكم عند الحاجة لتغيير في العام الثالث.
        </p>
      </ArBlock>

      <ArBlock tint="cream">
        <ArGrid columns={2} items={[
          { title: "شركة مقرها عُمان", desc: "مسجّلة هنا، نعمل هنا، نبني وفق البيئة التنظيمية التي تعملون ضمنها فعليًا." },
          { title: "نبني بالذكاء الاصطناعي", desc: "هكذا يستطيع فريق صغير ومتمرس تسليم في أسابيع ما كان يحتاج فريقًا كبيرًا ونصف عام." },
          { title: "الامتثال مُصمَّم من البداية", desc: "التزامات قانون حماية البيانات مبنية داخل المنتج منذ أول مرحلة، و Meyar لحوكمتها لاحقًا." },
          { title: "نبقى", desc: "دعم بموجب اتفاقية خدمة مكتوبة، أو تسليم نظيف بضمان 90 يومًا. اختياركم." },
        ]} />
      </ArBlock>

      <ArWhatHappensNext />
      <ArContactCTA heading="لنبنِ لكم ما يدوم." />
    </div>
  );
}
